import gql from 'graphql-tag';

export const getChannel = gql`
	query getChannel($id: ID!) {
		getChannel(id: $id) {
			id
			name
			language
			territory
			highlights
			type
			mediaLiveId
			mediaPackageId
			sourceAssets {
				items {
					id
					format
					url
					cdnIdentifierArn
				}
			}
		}
	}
`;

export const listChannels = gql`
	query listChannels($filter: ListChannelsFilterInput, $territory: String) {
		listChannels(filter: $filter, territory: $territory) {
			items {
				id
				name
				language
				territory
				highlights
				type
			}
		}
	}
`;
